<template>
    <div class="bill_template gridall" :data-no-translate="!$root.invoicePrintInSelectedLanguage || null" :class="{[templateClass]: true, 'font_small':invoiceFieldsObj.fontSize.value=='small', 'font_large':invoiceFieldsObj.fontSize.value=='large' && !$root.TransactionSettings.fullPagePrint, 'font_xl':invoiceFieldsObj.fontSize.value=='xl' && !$root.TransactionSettings.fullPagePrint, 'font_xxl':invoiceFieldsObj.fontSize.value=='xxl' && !$root.TransactionSettings.fullPagePrint, 'single-page':pages.length == 1, 'multi-page':pages.length > 1}">
		<!-- <div id="displayArea" style="visibility: hidden;"></div> -->
        <div id="printArea">
			<template v-if="isLoaded">
				<!-- {{ data }} -->
				<div class="page fullpage" v-for="(page, pageIndex) in pages" :class="{'last_page':pageIndex === pages.length - 1}" :id="'page_'+(pageIndex + 1)">
						
						<div class="header">
							<table style="text-align:left;height:100%">

								<!-- <tr>
									<td colspan="3" left-align :style="{'background':invoiceColor}" class="noborder pt-1">
										<div full-height class="title invoice_title pt-1 pb-1 center-align" style="height: 16px !important;">
											<template v-if="$root.CurrentBusiness.GSTRegistrationStatus == 1 && data.transactionDetails.transactionListId == 10003">
												{{summary.totalTax && !hasNilRatedItems ? data.transactionDetails.invoiceTitle : summary.totalTax && hasNilRatedItems ? 'Invoice-cum-Bill of Supply' : 'Bill Of Supply'}}
											</template>
											<template v-else>
												{{data.transactionDetails.invoiceTitle}}
											</template>
										</div>
									</td>
								</tr>

								<tr v-if="irnNumberQR">
									<td class="noborder border-bottom business_row" :colspan="headers.length" :class="{'pt-3':isEditable}">

										<div class="col50_2 no-right-padding no-left-padding">
											<div>IRN: {{ this.data.transactionDetails.additionalData.eInvoiceDetails.irnNumber }}</div>
											<div>Ack No.: {{ this.data.transactionDetails.additionalData.eInvoiceDetails.ackNumber }}</div>
											<div>Ack Date.: {{ this.data.transactionDetails.additionalData.eInvoiceDetails.ackDate | moment("DD-MMM-YYYY") }}</div>
										</div>

										<div class="col50_2 no-right-padding no-left-padding right-align">
											<div font10 class="mb-1">E-Invoice</div>
											<img width="48" :src="irnNumberQR" alt="irnnumber_qrcode">
										</div>
									</td>
								</tr>

								<tr right-align v-if="!data.transactionDetails.status">
									<td class="noborder redcolor" colspan="3">Cancelled!</td>
								</tr>

								<tr center-align v-if="subtitle.data && subtitle.data.content">
									<td class="noborder" :colspan="3">
										<div v-html="subtitle.data.content" v-ripple :class="{'editable':isEditable}" @click="fn_editPrintField(subtitle.fieldId)"></div>
									</td>
								</tr>

								<tr>
									<td class="noborder business_row border-bottom-none" :colspan="headers.length" :class="{'pt-3':isEditable}">
										<header-component ref="ref_headerComponent"></header-component>
									</td>
								</tr> -->

								

								<!-- <tr>
									<td style='width:50%;padding:0'>
										<div pad4 style="border-bottom:1px #000 solid">
											<h2>ABC TRADERS</h2>
											GSTIN: 27ABCDE1234F1Z5
										</div>

										<div pad4 style="border-bottom:1px #000 solid">
											Bill To <br>
											Abc Party<br>
											Abc Party<br>
											Abc Party<br>
											New Delhi
										</div>

										<div pad4>
											Ship To <br>
											Abc Party<br>
											Abc Party<br>
											Abc Party<br>
											New Delhi
										</div>
									</td>
									<td style="width:25%;padding:4px">
										Invoice No: INV001 <br>
										Invoice Date: 30/12/2025
									</td>
									<td style="width:25%;padding:4px">
										PO No. 001 <br>
										PO Date: 30/12/2025
									</td>
								</tr> -->
								<!-- <header-component ref="ref_headerComponent"></header-component> -->
								 <component :is="headerComponent" ref="ref_headerComponent"></component>
							</table>
						</div>

						<table class="items_table">
							<!-- <thead>
								<tr>
									<th>S.No.</th>
									<th>Description</th>
									<th>Qty</th>
									<th>Rate</th>
									<th>Discount</th>
									<th>Taxable Value</th>
									<th>CGST</th>
									<th>SGST</th>
									<th>Total</th>
								</tr>
							</thead> -->
							
							<colgroup v-if="!invoiceFieldsObj.autoColumnsWidth.value">
								<col class="content_width_cols" v-if="descriptionColspan && descriptionColspan > 1" v-for="(col, colIndex) in (descriptionColspan - 1)" :key="colIndex"></col>
								<template v-for="(col, colIndex) in headers">
									<col :class="{'content_width_cols':col.name != 'Description'}" :key="colIndex" v-if="showHideHeader(col.id)"></col>
								</template>
							</colgroup>

							<thead v-if="(filteredItems && filteredItems.length && page.items && page.items.length) || !filteredItems || (filteredItems && !filteredItems.length)" class="noborder items_header" @click="fn_openToggleOptions(invoiceFieldsObj, 'InvoiceTable')">

								<tr class="items_header_row items_header noborder" :style="{'background':invoiceColor}">
									<template v-for="(header, index) in headers">
										<td :colspan="header.name == 'Description' ? descriptionColspan : 1" v-if="showHideHeader(header.id)" class="noborder" :key="index" :class="{'right-align':  header.name!='#' && header.name!='Description' && header.name!='HSN/SAC' && header.name!='Batch#', 'fade-opacity':fadeHeaderOpacity(header.id)}" :style="{'minWidth':header.name=='Description' ? '30%' : 'auto'}">
											<!-- <strong>{{header.name}}</strong> -->
											<template v-if="invoiceFieldsObj[header.id] && header.id != 'tableColGST' && header.id != 'tableColDiscount'">
												<strong>{{invoiceFieldsObj[header.id].sectionName}}</strong>
											</template>
											<template v-else>
												<strong>{{header.name}}</strong>
											</template>
											
										</td>
									</template>
								</tr>

							</thead>

							<tbody class="items_body" :class="{'border-top-dark':!filteredItems || (filteredItems && !filteredItems.length)}">
								<!-- <tr v-for="item in page">
									<td>{{item.sno}}</td>
									<td>{{item.name}}</td>
									<td center-align>{{item.qty}}</td>
									<td right-align>{{item.rate.toFixed(2)}}</td>
									<td center-align>{{item.discount}}</td>
									<td center-align>{{item.taxableValue}}</td>
									<td center-align>{{item.cgst}}</td>
									<td center-align>{{item.sgst}}</td>
									<td right-align>2500</td>
								</tr> -->

								<!-- <template v-for="(item, groupIndex) in filteredItems" class="noborder" v-if="filteredItems && filteredItems.length"> -->
									<!-- <tr v-if="isRef && !invoiceFieldsObj.hideBaseTransactionNumber.status" class="noborder border-bottom"><td class="noborder" :colspan="headers.length"><strong>{{item.baseTransactionNumber}}</strong></td></tr> -->
									<template v-for="(row, index) in page.items">
										
										<tr :key="'base_number'+row.baseTransactionNumber" v-if="isRef && !invoiceFieldsObj.hideBaseTransactionNumber.status && row.isBaseNumber === true" class="noborder border-bottom"><td class="noborder" :colspan="headers.length"><strong>{{row.baseTransactionNumber}}</strong></td></tr>
										
										<tr :key="'item_' + index" class="noborder border-bottom items_row" :class="{'add_bottom_border':invoiceFieldsObj.itemRowBorder.value && index != page.items.length - 1}"  v-if="!row.isBaseNumber">
											<!-- <td>{{index+1}}</td> -->
											<!-- <td>{{row.srNo}}</td> -->

											<td>
												{{
													invoiceFieldsObj.hideBaseTransactionNumber.status
													? index + 1
													: row.srNo
												}}
											</td>

											<td style="width: 30%;" :colspan="descriptionColspan" class="item_details">
												
												<template v-if="fn_getEnabledItemsDetailsArray() && fn_getEnabledItemsDetailsArray().length">
													<template v-for="(itemDetail, itemDetailsIndex) in fn_getEnabledItemsDetailsArray()">
														<template v-if="row[fn_getItemDetailKey(itemDetail.fieldId)] && fn_showSection(itemDetail.status)">
															<br v-if="!invoiceFieldsObj.itemDetailsAlignment.status && itemDetailsIndex != 0">
															<span class="description_row" :class="{'fade-opacity':!itemDetail.status}">
																<template v-if="itemDetail.fieldId == 'tableColItemName'">
																	<span :class="{'font-heavy':invoiceFieldsObj.tableColItemName.isBold}">{{ row[fn_getItemDetailKey(itemDetail.fieldId)] }}</span>
																</template>
																<template v-else>
																	<em><span v-html="row[fn_getItemDetailKey(itemDetail.fieldId)]"></span></em>
																</template>
															</span>
															<span v-if="invoiceFieldsObj.itemDetailsAlignment.status"> / </span>
														</template>
													</template>
												</template>

												<template v-else>
													{{row.itemName}}
												</template>
												

												<!-- displaying custom item fields under item name -->
												<template v-if="otherFieldsPosValue == 2">
													<br>
													<span class="description_row" v-for="(field, fieldIndex) in row.customFields" :key="fieldIndex + field.fieldId" :class="{'fade-opacity':!invoiceFieldsObj[field.fieldId].status}" v-if="fn_showSection(invoiceFieldsObj[field.fieldId].status)">
														<br v-if="fieldIndex != 0">
														<span v-if="field.fieldType == 'dateTime'">
															<em>{{field.fieldValue | moment("DD-MMM-YYYY")}}</em>
														</span>
														<span v-else>
															<em>{{field.value}}</em>
														</span>
													</span>
												</template>

												<br v-if="row.field1 || row.field2 || row.field3 || row.field4">
												<template v-if="row.field1 && row.field1.length">
													<span>Serial Number: </span>
													<span class="description_row" v-for="(field, index) in row.field1" :key="index">{{ field }} <span v-if="row.field1.length - 1 != index">, </span></span>
													<br>
												</template>

												<template v-if="row.field2 && row.field2.length">
													<span>IMEI Number: </span>
													<span class="description_row" v-for="(field, index) in row.field2" :key="index">{{ field }} <span v-if="row.field2.length - 1 != index">, </span></span>
													<br>
												</template>

												<template v-if="row.field3 && row.field3.length">
													<span>Part Number: </span>
													<span class="description_row" v-for="(field, index) in row.field3" :key="index">{{ field }} <span v-if="row.field3.length - 1 != index">, </span></span>
													<br>
												</template>

												<template v-if="row.field4 && row.field4.length">
													<span>Model Number: </span>
													<span class="description_row" v-for="(field, index) in row.field4" :key="index">{{ field }} <span v-if="row.field4.length - 1 != index">, </span></span>
												</template>

											</td>

											<td right-align v-for="(header, headerIndex) in headers" :key="headerIndex" v-if="header.fieldId && fn_showSection(invoiceFieldsObj[header.id].status) && otherFieldsPosValue == 1" :class="{'fade-opacity':!invoiceFieldsObj[header.id].status}">
												<span v-for="(field, fieldIndex) in row.customFields" :key="fieldIndex" v-if="header.fieldId == field.fieldId">
													<template v-if="field.fieldType == 'dateTime'">
														{{field.value | moment("DD-MMM-YYYY")}}
													</template>
													<template v-else>
														{{field.value}}
													</template>
												</span>
											</td>
											
											<td v-if="isHsn">{{row.hsn ? row.hsn : '-'}}</td>

											<td right-align :class="{'fade-opacity':!invoiceFieldsObj.tableColQty.status}" v-if="fn_showSection(invoiceFieldsObj.tableColQty.status)">{{row.qty}}</td>
											
											<td v-if="row.batchNumber != undefined" class="break_word">{{row.batchNumber}}</td>
											<td right-align v-if="row.batchSize != undefined">{{row.batchSize}}</td>
											<td style="min-width: 65px;" right-align v-if="row.mfgDate != undefined">{{row.mfgDate}}</td>
											<td style="min-width: 65px;" right-align v-if="row.expDate != undefined">{{row.expDate}}</td>
											<td right-align v-if="row.purchaseRate != undefined">{{row.purchaseRate}}</td>

											<td right-align :class="{'fade-opacity':!invoiceFieldsObj.tableColUnit.status}" v-if="fn_showSection(invoiceFieldsObj.tableColUnit.status)">{{row.unit}}</td>

											<td right-align :class="{'fade-opacity':invoiceFieldsObj.tableColMrp && !invoiceFieldsObj.tableColMrp.status}" v-if="invoiceFieldsObj.tableColMrp && fn_showSection(invoiceFieldsObj.tableColMrp.status) && isMrp">{{row.mrp ? $root.fixed2Decimal(row.mrp) : ''}}</td>
											<td right-align :class="{'fade-opacity':!invoiceFieldsObj.tableColRate.status}" v-if="fn_showSection(invoiceFieldsObj.tableColRate.status)">{{row.rate ? row.rate : ''}}</td>

											<td right-align :class="{'fade-opacity':!invoiceFieldsObj.tableColPrimaryQty.status}" v-if="invoiceFieldsObj.tableColPrimaryQty && fn_showSection(invoiceFieldsObj.tableColPrimaryQty.status)">{{row.primaryQty}}</td>
											<td right-align :class="{'fade-opacity':!invoiceFieldsObj.tableColSecondaryQty.status}" v-if="invoiceFieldsObj.tableColSecondaryQty && fn_showSection(invoiceFieldsObj.tableColSecondaryQty.status)">{{row.secondaryQty}}</td>
											
											<td right-align :class="{'fade-opacity':!invoiceFieldsObj.tableColPacking.status}" v-if="isPacking && fn_showSection(invoiceFieldsObj.tableColPacking.status)">{{row.packing}}</td>

											<td right-align v-for="(header, headerIndex) in headers" :key="headerIndex" v-if="header.addOnsId && fn_showSection(invoiceFieldsObj.tableColDiscount.status)" :class="{'fade-opacity':!invoiceFieldsObj.tableColDiscount.status}">
												<span v-for="(addOn, addOnIndex) in row.addOns" :key="addOnIndex" v-if="header.addOnsId == addOn.addOnsId">
													
													<template v-if="$root.TransactionSettings.enableSingleLineAddOns">
														<span v-if="addOn.percentage && (invoiceFieldsObj.tableColDiscount.optionFlag == 1 || isEditable)" :class="{'fade-opacity': invoiceFieldsObj.tableColDiscount.optionFlag != 1}">@</span><span v-if="addOn.percentage && (invoiceFieldsObj.tableColDiscount.optionFlag != 3 || isEditable)" :class="{'fade-opacity': invoiceFieldsObj.tableColDiscount.optionFlag == 3}">{{addOn.percentage + '%'}}</span>&nbsp;<span v-if="isEditable || invoiceFieldsObj.tableColDiscount.optionFlag != 2" :class="{'fade-opacity': invoiceFieldsObj.tableColDiscount.optionFlag == 2}">{{addOn.value ? $root.fixed2Decimal(addOn.value) : ''}}</span>
													</template>

													<template v-else>
														<span v-if="isEditable || invoiceFieldsObj.tableColDiscount.optionFlag != 2" :class="{'fade-opacity': invoiceFieldsObj.tableColDiscount.optionFlag == 2}">{{addOn.value ? $root.fixed2Decimal(addOn.value) : ''}}</span>
														<br v-if="addOn.percentage && (addOn.value && invoiceFieldsObj.tableColDiscount.optionFlag == 1 || isEditable)">
														<span v-if="addOn.percentage && (invoiceFieldsObj.tableColDiscount.optionFlag == 1 || isEditable)" :class="{'fade-opacity': invoiceFieldsObj.tableColDiscount.optionFlag != 1}">@</span>
														<span v-if="addOn.percentage && (invoiceFieldsObj.tableColDiscount.optionFlag != 3 || isEditable)" :class="{'fade-opacity': invoiceFieldsObj.tableColDiscount.optionFlag == 3}">{{addOn.percentage + '%'}}</span>
													</template>
													
												</span>
											</td>
											
											<td right-align :class="{'fade-opacity':!invoiceFieldsObj.tableColTaxableRate.status}" v-if="fn_showSection(invoiceFieldsObj.tableColTaxableRate.status)">{{row.taxableRate ? row.taxableRate : ''}}</td>
											<td right-align v-if="hasTaxableColumn && gstAddOnsTotal && gstAddOnsTotal.length && (fn_showSection(invoiceFieldsObj.tableColTaxableValue.status) || invoiceFieldsObj.tableColTaxableValue2.status)" :class="{'fade-opacity':!invoiceFieldsObj.tableColTaxableValue.status && !invoiceFieldsObj.tableColTaxableValue2.status}">{{row.taxableValue ? $root.fixed2Decimal(row.taxableValue) : ''}}</td>
											
											<td right-align v-for="(header, headerIndex) in headers" :key="headerIndex" v-if="header.gstAddOnsId && fn_showSection(invoiceFieldsObj.tableColGST.status)" :class="{'fade-opacity':!invoiceFieldsObj.tableColGST.status}">
												<span v-for="(addOn, addOnIndex) in row.gstAddOns" :key="addOnIndex" v-if="header.gstAddOnsId == addOn.addOnsId">
													<template v-if="!addOn.cessValueOnQuantity">
														<span v-if="$root.TransactionSettings.enableSingleLineAddOns && addOn.percentage != null"><template v-if="getGstColumnType == 2 || getGstColumnType == 4">@</template>{{addOn.percentage + '%'}}&nbsp;</span><span v-if="isEditable || (getGstColumnType == 2 || getGstColumnType == 4)" :class="{'fade-opacity': getGstColumnType != 2 && getGstColumnType != 4}">{{addOn.value != null || addOn.value != undefined ? $root.fixed2Decimal(addOn.value) : ''}}</span>
														<span v-if="!$root.TransactionSettings.enableSingleLineAddOns && addOn.percentage != null"><br><template v-if="getGstColumnType == 2 || getGstColumnType == 4">@</template>{{addOn.percentage + '%'}}</span>
													</template>
													<template v-else>
														{{$root.fixed2Decimal(addOn.value)}}
													</template>

												</span>
											</td>
											<td right-align :class="{'fade-opacity':!invoiceFieldsObj.tableColTotal.status}" v-if="fn_showSection(invoiceFieldsObj.tableColTotal.status)">{{row.rate ? $root.numberToLocale(roundUpto2Decimals(row.total)) : 'Free'}}</td>
										</tr>
									</template>
								<!-- </template> -->
				
								<tr class="items_footer noborder border-bottom" id="item_total_footer_1001" v-if="filteredItems && filteredItems.length && pageIndex === pages.length - 1" :style="{'background':invoiceColor}">
									<!-- <td :colspan="isHsn ? 3 : 2"><strong>Total (&#8377;)</strong></td> -->
									<td :colspan="isHsn && !fn_customFieldColSize() ? 3 : 2"><strong>Total (&#8377;)</strong></td>

									<td v-if="descriptionColspan && descriptionColspan > 1" :colspan="descriptionColspan - 1"></td>

									<!-- <td :colspan="fn_customFieldColSize()" v-if="fn_customFieldColSize() && otherFieldsPosValue == 1"></td> -->

									<template v-if="invoiceFieldsObj.itemCustomFieldTotal.status">
										<td right-align v-for="(header, headerIndex) in headers" :key="headerIndex" v-if="header.fieldId && fn_showSection(invoiceFieldsObj[header.id].status) && otherFieldsPosValue == 1" :class="{'fade-opacity':!invoiceFieldsObj[header.id].status}">
											<strong>{{ fn_getFieldTotalValue(header.fieldId) }}</strong>
										</td>
									</template>
									<template v-else>
										<td :colspan="fn_customFieldColSize()" v-if="fn_customFieldColSize() && otherFieldsPosValue == 1"></td>
									</template>

									<td v-if="isHsn && fn_customFieldColSize()"></td>
									
									<td right-align :class="{'fade-opacity':!invoiceFieldsObj.tableColQty.status}" v-if="fn_showSection(invoiceFieldsObj.tableColQty.status)">
										<strong>{{qtyTotal ? qtyTotal : ''}}</strong>
									</td>

									<td :colspan="fn_footerColspanSize()" v-if="fn_footerColspanSize() > 0"></td>

									<td right-align :class="{'fade-opacity':!invoiceFieldsObj.tableColPrimaryQty.status}" v-if="invoiceFieldsObj.tableColPrimaryQty && fn_showSection(invoiceFieldsObj.tableColPrimaryQty.status)">
										<strong>{{primaryQtyTotal ? primaryQtyTotal : ''}}</strong>
									</td>

									<td right-align :class="{'fade-opacity':!invoiceFieldsObj.tableColSecondaryQty.status}" v-if="invoiceFieldsObj.tableColSecondaryQty && fn_showSection(invoiceFieldsObj.tableColSecondaryQty.status)">
										<strong>{{secondaryQtyTotal ? secondaryQtyTotal : ''}}</strong>
									</td>
									
									<td right-align v-for="(header, headerIndex) in headers" :key="headerIndex" v-if="header.addOnsId && fn_showSection(invoiceFieldsObj.tableColDiscount.status)" :class="{'fade-opacity':!invoiceFieldsObj.tableColDiscount.status}">
										<span v-for="(item, index) in addOnsTotal" :key="index" v-if="header.addOnsId == item.addOnsId && invoiceFieldsObj.tableColDiscount.optionFlag != 2">
											<strong v-if="item.value">{{$root.numberToLocale(item.value)}}</strong>
										</span>
									</td>

									<td right-align v-if="fn_showSection(invoiceFieldsObj.tableColTaxableRate.status)"></td>
									<td right-align v-if="data.transactionDetails.taxableValue && gstAddOnsTotal && gstAddOnsTotal.length && (fn_showSection(invoiceFieldsObj.tableColTaxableValue.status) || invoiceFieldsObj.tableColTaxableValue2.status)" :class="{'fade-opacity':!invoiceFieldsObj.tableColTaxableValue.status && !invoiceFieldsObj.tableColTaxableValue2.status}"><strong>{{$root.numberToLocale(data.transactionDetails.taxableValue)}}</strong></td>
									
									<td right-align v-for="(header, headerIndex) in headers" :key="headerIndex" v-if="header.gstAddOnsId && fn_showSection(invoiceFieldsObj.tableColGST.status)" :class="{'fade-opacity':!invoiceFieldsObj.tableColGST.status}">
										<span v-for="(item, index) in gstAddOnsTotal" :key="index" v-if="header.gstAddOnsId == item.gstAddOnsId && (getGstColumnType == 2 || getGstColumnType == 4)">
											<strong>{{$root.numberToLocale(item.value)}}</strong>
										</span>
									</td>

									<td right-align :class="{'fade-opacity':!invoiceFieldsObj.tableColTotal.status}" v-if="invoiceFieldsObj.tableColTotal && fn_showSection(invoiceFieldsObj.tableColTotal.status)"><strong>{{$root.numberToLocale(netTotal)}}</strong></td>
								</tr>

								<!-- Body in case of direct amount invoice (no items) -->
								<template v-if="filteredItems && !filteredItems.length">
									<tr class="items_row">
										<td>1</td>
										<td style="width: 80%;"><span class="description_row">{{data.transactionDetails.description}}</span></td>
										<td class="right-align">{{$root.numberToLocale(data.transactionDetails.taxableValue)}}</td>
									</tr>

									<!-- Footer in case of direct amount invoice (no items) -->
									<tr class="items_footer noborder border-bottom" :style="{'background':invoiceColor}">
										<td colspan="2"><strong>Total</strong></td>
										<td class="right-align"><strong>{{$root.numberToLocale(data.transactionDetails.taxableValue)}}</strong></td>
									</tr>
								</template>
							</tbody>
						</table>

						<div class="spacer">{{pages.length>1 && pageIndex != pages.length - 1 ? 'Continue...' : ''}}</div>

						<div class="fullpage_footer" :class="{'border-bottom-dark':!hasFooterSection}" v-if="pageIndex === pages.length - 1">
							<table>

								<!-- Total summary -->
								<tr class="border-bottom" :class="{'border-top':!filteredItems.length}" v-if="isEditable || invoiceFieldsObj.amountInWords.status || invoiceFieldsObj.taxAndTotal.status">
									<td :colspan="headers.length" class="single-column-double-section noborder" style="height:1px !important">
										<div full-height class="left-column">

											<div class="mb-2" v-if="unitSummary.length">
												<strong>Total Qty: </strong>
												<span v-for="(unit, uIndex) in unitSummary" :key="uIndex">
													{{ unit.qty }} {{ unit.unitName }}<span v-if="uIndex != unitSummary.length - 1">,</span>
												</span>
											</div>

											<div class="pb-1" v-if="fn_showSection(invoiceFieldsObj.amountInWords.status)" :class="{'editable':isEditable, 'fade-opacity':!invoiceFieldsObj.amountInWords.status}">
												<div>
													<strong>Total amount (in words)</strong><br>
													{{convertNumberToWords(data.transactionDetails.roundedAmount)}} Only.
												</div>
											</div>

											<div v-if="isEditable">
												<v-switch class="hide-margins small-switch float-right mr-1 mt-1" hide-details :height="17" nopadding v-model="invoiceFieldsObj.amountInWords.status" @change="fn_copyFieldObj(invoiceFieldsObj.amountInWords)"></v-switch>
											</div>

											<div v-if="data.transactionDetails.notes" class="pt-1 topborder">
												<strong>Note</strong><br>
												<span v-html="data.transactionDetails.notes"></span>
											</div>

										</div>

										<div full-height class="right-column no-right-padding" right-align>
											<div v-if="fn_showSection(invoiceFieldsObj.taxAndTotal.status)" :class="{'editable':isEditable, 'fade-opacity':!invoiceFieldsObj.taxAndTotal.status}">
												<div class="table_div">
													<template v-if="showTaxLabels()">
														<div class="table_div_row">
															<div class="table_div_col">Taxable Amount (&#8377;):</div>
															<div class="table_div_col pr-1" right-align>
																<strong>{{$root.numberToLocale(data.transactionDetails.taxableValue)}}</strong>
															</div>
														</div>
														<div class="table_div_row">
															<div class="table_div_col"><span>Tax</span>
																<template v-if="itemGstPercentage && gstAddOnsTotal && gstAddOnsTotal.length">@{{ itemGstPercentage }}%</template>
																{{data.transactionDetails.isRcmApplicable ? '(RCM)' : ''}} (&#8377;):
															</div>
															<div class="table_div_col pr-1" right-align>
																<strong>{{$root.numberToLocale(summary.totalTax)}}</strong>
															</div>
														</div>
													</template>

													<div class="table_div_row" v-if="data.transactionDetails.transactionTds && data.transactionDetails.transactionTds.length">
														<div class="table_div_col">
															{{data.transactionDetails.transactionTds[0].tdsAccountName}} (&#8377;):
														</div>
														<div class="table_div_col pr-1" right-align>
															<strong>-{{$root.numberToLocale(data.transactionDetails.transactionTds[0].amount)}}</strong>
														</div>
													</div>

													<div class="table_div_row" v-for="(addOn, addOnIndex) in data.transactionDetails.transactionAddOns" :key="addOnIndex">
														<div class="table_div_col">{{addOn.name}} <span v-if="addOn.percentage">@{{ addOn.percentage }}%</span> {{addOn.isGst == 1 && data.transactionDetails.isRcmApplicable ? '(RCM)' : ''}} (&#8377;):</div>
														<div class="table_div_col pr-1" right-align>
															{{addOn.nature == 1 ? '-' : ''}}<strong>{{$root.numberToLocale(addOn.value)}}</strong>
														</div>
													</div>
													<div class="table_div_row" v-if="roundOffAmount">
														<div class="table_div_col">Round Off (&#8377;):</div>
														<div class="table_div_col pr-1" right-align>
															<strong>{{$root.numberToLocale(roundOffAmount)}}</strong>
														</div>
													</div>
													<div class="table_div_row">
														<div class="table_div_col"><strong>Total Amount (&#8377;):</strong></div>
														<div class="table_div_col pr-1" right-align>
															<strong>{{$root.numberToLocale(data.transactionDetails.roundedAmount)}}</strong>
														</div>
													</div>

													<template v-if="data.transactionDetails.paymentAccounts && data.transactionDetails.paymentAccounts.length">

														<!-- if multiple payment modes -->
														<div class="table_div_row" v-for="(item, index) in data.transactionDetails.paymentAccounts" :key="index" v-if="!invoiceFieldsObj.hidePaymentInfo.status">
															<div class="table_div_col">Paid - {{item.accountLedgerName == 'Cash A/c' ? 'Cash' : item.accountLedgerName}} (&#8377;):</div>
															<div class="table_div_col pr-1" right-align>
																<strong>{{$root.numberToLocale(item.amount)}}</strong>
															</div>
														</div>

													</template>

													<div class="table_div_row" v-if="showBalanceLabel() && fn_showSection(invoiceFieldsObj.tableColSummaryBalance.status)" :class="{'fade-opacity':!invoiceFieldsObj.tableColSummaryBalance.status}">
														<div class="table_div_col"><strong>{{invoiceFieldsObj['tableColSummaryBalance'].sectionName}}</strong> (&#8377;):</div>
														<div class="table_div_col pr-1" right-align>
															<strong>{{data.transactionDetails.onCredit ? $root.numberToLocale(data.transactionDetails.onCredit) : '0'}}</strong>
														</div>
													</div>

													<template v-if="$root.TransactionSettings.showPartyBalance && (data.transactionDetails.transactionListId == '10003' || data.transactionDetails.transactionListId == '10004' || data.transactionDetails.transactionListId == '20003' || data.transactionDetails.transactionListId == '20004' || data.transactionDetails.transactionListId == '20005')">
														<div class="table_div_row" v-if="data.transactionDetails.lastInvoice">
															<div class="table_div_col">Previous Balance (&#8377;):</div>
															<div class="table_div_col pr-1" right-align>
																{{$root.numberToLocale(fn_previousBalance())}}
															</div>
														</div>

														<div class="table_div_row">
															<div class="table_div_col">Current Balance (&#8377;):</div>
															<div class="table_div_col pr-1" right-align>
																<strong>{{$root.numberToLocale(data.transactionDetails.partyDetails.currentBalance)}}</strong>
															</div>
														</div>
													</template>

												</div>
											</div>

											<div v-if="isEditable">
												<v-switch class="hide-margins small-switch float-right mr-1 mt-1" hide-details :height="17" nopadding v-model="invoiceFieldsObj.taxAndTotal.status" @change="fn_copyFieldObj(invoiceFieldsObj.taxAndTotal)"></v-switch>
											</div>
										</div>

									</td>
								</tr>


								<!-- HSN Summary -->
								<template v-if="hsnSummary.items.length && fn_showSection(invoiceFieldsObj.hsnSummary.status)" :class="{'editable':isEditable}">
									<tr :style="{'background':invoiceColor}" class="hsn_row_1001 border-bottom noborder hsn-summary-headers" :class="{'fade-opacity':!invoiceFieldsObj.hsnSummary.status}">
										<td font-heavy center-align :colspan="fn_hsnSummaryColspan()">HSN/SAC</td>
										<td font-heavy right-align :colspan="index == 0 || index == hsnSummary.headers.length - 1 ? 2 : 1" class="hsn-dynamic-headers" v-for="(hsnHeader, index) in hsnSummary.headers">{{ hsnHeader.name }}</td>
									</tr>

									<tr class="hsn_row_1001 border-bottom noborder" v-for="(summary, summaryIndex) in hsnSummary.items" :class="{'fade-opacity':!invoiceFieldsObj.hsnSummary.status}">
										<td :colspan="fn_hsnSummaryColspan()">{{summary.hsn}}</td>
										<td right-align :colspan="2">{{$root.fixed2Decimal(summary.taxableValue)}}</td>
										<td right-align v-for="gst in summary.gstAddOns" :key="gst.addOnsId">
											{{gst.value != null ? $root.fixed2Decimal(gst.value) : ''}} <br>
											<template v-if="!gst.cessValueOnQuantity">
												<span v-if="gst.percentage !=undefined">{{ '@' + gst.percentage + '%' }}</span>
											</template>
											<template v-else>
												<template>{{ gst.cessValueOnQuantity }}/{{ summary.unit }}</template>
											</template>
										</td>
										<td v-if="fn_hsnSummaryCessQtyEmptyCol(summaryIndex)"></td>
										<td right-align :colspan="2">{{$root.numberToLocale(summary.totalTax)}}</td>
									</tr>

									<tr :style="{'background':invoiceColor}" class="hsn_row_1001 border-bottom noborder" :class="{'fade-opacity':!invoiceFieldsObj.hsnSummary.status}">
										<td font-heavy :colspan="fn_hsnSummaryColspan()">Total</td>
										<td right-align font-heavy :colspan="index == 0 || index == hsnSummary.footers.length - 1 ? 2 : 1" v-for="(footerValue, index) in hsnSummary.footers">{{$root.numberToLocale(footerValue)}}</td>
									</tr>

									<tr v-if="isEditable">
										<td style="border-color: #fff !important;" :colspan="headers.length">
											<v-switch class="hide-margins small-switch float-right mr-1 mt-1" hide-details :height="17" nopadding v-model="invoiceFieldsObj.hsnSummary.status" @change="fn_copyFieldObj(invoiceFieldsObj.hsnSummary)"></v-switch>
										</td>
									</tr>

								</template>


								<tr v-if="hasFooterSection">
									<td :colspan="headers.length" class="noborder" :class="{'pt-4':isEditable}">
										<footer-component v-if="dataLoaded"></footer-component>
									</td>
								</tr>

								<tr v-if="fn_showSection(invoiceFieldsObj.bottomNote.status)">
									<td center-align class="noborder borderwhite" :colspan="headers.length" style="border:0px !important">
										<div class="pa-1"v-ripple style="height:auto;" :class="{'fade-opacity':!invoiceFieldsObj.bottomNote.status, 'editable mt-3':isEditable}" @click="fn_addNote('bottom_note')">
											<div v-html="invoiceFieldsObj.bottomNote.value" v-if="invoiceFieldsObj.bottomNote.value"></div>
											<div v-else>This is a Computer Generated Invoice.</div>
											<div class="editabled-field-label" v-if="isEditable"><v-icon>edit</v-icon> Edit</div>
										</div>  

										<div v-if="isEditable" style="height:auto;">
											<v-switch class="hide-margins small-switch float-right mr-1 mt-1" hide-details :height="17"  nopadding v-model="invoiceFieldsObj.bottomNote.status" @change="fn_copyFieldObj(invoiceFieldsObj.bottomNote)"></v-switch>
										</div>
									</td>
								</tr>
								
							</table>
						</div>
						<!-- <div class="footer" v-if="pageIndex === pages.length - 1">
								<table>
									<tr>
										<td><strong>Total amount in words</strong> <br> <span>One Thousand Fifty Only.</span></td>
										<td>
											Taxable Amount (₹): 1,000.00<br>
											Tax @5% (₹): 50.00<br>
											Total Amount (₹): 1,050.00<br>
											Remaining Amount (₹): 1,050.00<br>    
										</td>
									</tr>

									<tr>
										<td>
											<strong>Terms:</strong><br>
											1. All disputes are subject to Delhi Jurisdiction.<br>
											2. Certified that the particulars given above are true and correct.
										</td>
										<td></td>
									</tr>
								</table>
						</div> -->
				</div>
			</template>
		</div>
    </div>
</template>

<script>
import {invoiceTemplateMixin} from '../invoice_template_mixin'
import footerComponent from '../components/invoice_footer_section'
// import headerComponent from '../components/invoice_headers'

export default{
    mixins: [invoiceTemplateMixin],
    components:{
        'footer-component':footerComponent,
		// 'header-component': headerComponent
    },
	data(){
		return{
			test:null,
			pages:[],
			isLoaded:false,
			headerComponent:null,
			hsnOnNewPage:false
		}
	},
	methods:{
		/* PAGINATE */
		paginate(type) {

			this.isLoaded = false;
			this.hsnOnNewPage = false;

			const PAGE_HEIGHT = 1122;
			// const PAGE_PADDING = 20;
			// removing zoom
			let zoomValue = null;
			if(document.getElementById('preview_wrapper')){
				zoomValue = document.getElementById('preview_wrapper').style.zoom;
				document.getElementById('preview_wrapper').style.zoom = '100%';
			}

			document.getElementsByClassName('template_'+this.data.templateSettings.invoiceTemplate)[0].style.width = '210mm';
			let headerElement = document.getElementById("header_template_" + this.data.templateSettings.invoiceTemplate);
			// headerElement.style.width = '210mm';
			const HEADER_HEIGHT = headerElement ? headerElement.offsetHeight : 300;
			// headerElement.style.width = '100%';
			
			let bottomSectionHeight = document.getElementById('bottom_section_body').offsetHeight;
			const FOOTER_HEIGHT = bottomSectionHeight > 200 ? bottomSectionHeight : 200;

			
			// let FOOTER_HEIGHT = 120;
			// let FOOTER_HEIGHT = 0;
			// if(this.invoiceFieldsObj.fontSize.value=='large'){
			// 	FOOTER_HEIGHT = 60;
			// }
			// else if(this.invoiceFieldsObj.fontSize.value=='xl'){
			// 	FOOTER_HEIGHT = 80;
			// }
			// else if(this.invoiceFieldsObj.fontSize.value=='font_xxl'){
			// 	FOOTER_HEIGHT = 120;
			// }
			// const FOOTER_HEIGHT_WITH_HSN_SUMMARY = bottomSectionHeight > 200 ? bottomSectionHeight : 200;
			// const CONTENT_HEIGHT = PAGE_HEIGHT - PAGE_PADDING * 2 - HEADER_HEIGHT - FOOTER_HEIGHT;
			// const CONTENT_HEIGHT = PAGE_HEIGHT - HEADER_HEIGHT - FOOTER_HEIGHT;
			// const CONTENT_HEIGHT_WITH_HSN_SUMMARY = PAGE_HEIGHT - PAGE_PADDING * 2 - HEADER_HEIGHT - FOOTER_HEIGHT_WITH_HSN_SUMMARY;
			let hsnSummaryTotalHeight = 0;

			let hsnSummaryRows = null;
			// calculating hsn summary height
			if(this.hsnSummary.items.length && this.fn_showSection(this.invoiceFieldsObj.hsnSummary.status)){
				hsnSummaryRows = document.getElementsByClassName('hsn_row');
				for(let i=0; i<hsnSummaryRows.length; i++){
					hsnSummaryTotalHeight += hsnSummaryRows[i].offsetHeight;
				}
			}


			document.getElementsByClassName('template_'+this.data.templateSettings.invoiceTemplate)[0].style.width = '100%';
			if(document.getElementById('preview_wrapper')){
				document.getElementById('preview_wrapper').style.zoom = zoomValue;
			}

			const CONTENT_HEIGHT = PAGE_HEIGHT - HEADER_HEIGHT - FOOTER_HEIGHT + hsnSummaryTotalHeight;

			// const CONTENT_HEIGHT = PAGE_HEIGHT - PAGE_PADDING * 2 - HEADER_HEIGHT - FOOTER_HEIGHT - hsnSummaryTotalHeight;

			/* SAMPLE DATA */
			// const items = Array.from({ length: 10 }, (_, i) => ({
			// 	id: `item_${i + 1}`,
			// 	sno:i+1,
			// 	name: `Item ${i + 1} with description that may wrap into multiple lines`,
			// 	qty: (i % 4) + 1,
			// 	rate: 120 + i * 10,
			// 	discount:50,
			// 	taxableValue:1200,
			// 	cgst:100,
			// 	sgst:100,
			// }));
			
			const pages = [];
			let page = [];
			let used = 0;

            let btNumbers = [];

			if(this.filteredItems && this.filteredItems.length){
				this.filteredItems.forEach(baseTransaction=>{
					baseTransaction.items.forEach((item, index) => {
						// base transaction number row logic
						if(this.isRef && !this.invoiceFieldsObj.hideBaseTransactionNumber.status){
                            if(!btNumbers.includes(baseTransaction.baseTransactionNumber)){
                                btNumbers.push(baseTransaction.baseTransactionNumber);
                                let btItem = {};
                                btItem.baseTransactionNumber = baseTransaction.baseTransactionNumber;
                                btItem.isBaseNumber = true;
                                // let baseRow = document.querySelector('#'+baseTransaction.baseTransactionNumber);
								let baseRow = document.getElementById(baseTransaction.baseTransactionNumber);
                                const bh = baseRow.offsetHeight;
                                if (used + bh > CONTENT_HEIGHT) {
                                    pages.push({ items: page, usedHeight: used });
                                    page = [];
                                    used = 0;
                                }
                                page.push(btItem);
                                used += bh;
                            }
                        }

						let elementId = "#item_" + (index + 1);
						let itemRow = document.querySelector(elementId);
						// const h = rowHeight(item.name);
						const h = itemRow.offsetHeight;
						if (used + h > CONTENT_HEIGHT) {
							// pages.push(page);
							pages.push({ items: page, usedHeight: used });
							page = [];
							used = 0;
						}
						item.srNo = index + 1;
						page.push(item);
						used += h;
					});
				})
			}
			else{
				pages.push({ items: [], usedHeight: 0 });
			}
			
			

			// if(type){
			// 	items.forEach(item => {
			// 		page.push(item);
			// 	});
			// }
			// else{
			// 	items.forEach((item, index) => {
			// 		let elementId = "#item_" + (index + 1);
			// 		let rowheight = document.querySelector(elementId);
			// 		// const h = rowHeight(item.name);
			// 		const h = rowheight.offsetHeight;
			// 		if (used + h > CONTENT_HEIGHT) {
			// 			pages.push(page);
			// 			page = [];
			// 			used = 0;
			// 		}
			// 		page.push(item);
			// 		used += h;
			// 	});
			// }
			// items.forEach(item => {
				// const h = rowHeight(item.name);
				// if (used + h > CONTENT_HEIGHT) {
					// pages.push(page);
					// page = [];
					// used = 0;
				// }
				// page.push(item);
				// used += h;
			// });

			// if (page.length) pages.push(page);
			if (page.length) pages.push({ items: page, usedHeight: used });
			// return pages;
			this.pages = pages;

			/* Check if HSN fits on last page */
			const lastPage = pages[pages.length - 1];
			const remainingSpace = CONTENT_HEIGHT - lastPage.usedHeight;

			// this.hsnOnNewPage = remainingSpace < hsnSummaryTotalHeight;
			if(this.hsnSummary.items.length && this.fn_showSection(this.invoiceFieldsObj.hsnSummary.status)){
				// this.hsnOnNewPage = (remainingSpace + 20) < FOOTER_HEIGHT - hsnSummaryTotalHeight;	
				this.hsnOnNewPage = ((remainingSpace + 20) < FOOTER_HEIGHT) && ((remainingSpace + 20) < hsnSummaryTotalHeight);	
			}

			if(this.hsnOnNewPage){
				this.pages.push({items:[], usedHeight:0});
			}

			this.isLoaded = true;

			if(this.filteredItems && this.filteredItems.length){
				setTimeout(() => {
					// if(!pages[pages.length - 1].items.length){
					// 	// let itemTotalRow = document.getElementById('item_total_footer_1001');
					// 	const lastItemRow = document.querySelector('#page_'+(pages.length - 1) + ' tbody.items_body > tr:last-child');
					// 	let lastPageItemsBody = document.querySelector('#page_' + pages.length + ' tbody.items_body');
					// 	if(pages[pages.length - 2].usedHeight < (lastItemRow.offsetHeight + FOOTER_HEIGHT)){
					// 		lastPageItemsBody.prepend(lastItemRow);
					// 	}
					// }
					if(!pages[pages.length - 1].items.length){
						let itemTotalRow = document.getElementById('item_total_footer_1001');
						const tbody = document.querySelector('#page_'+(pages.length - 1) + ' tbody.items_body');
						tbody.appendChild(itemTotalRow);
					}

					if(this.hsnOnNewPage){
						let summaryRows = document.getElementsByClassName('hsn_row_1001');
						if(summaryRows && summaryRows.length){
							let lastPageItemsBody = document.querySelector('.last_page .items_body');
							for(let i=0; i<summaryRows.length; i++){
								lastPageItemsBody.appendChild(summaryRows[i]);
							}
						}

						let printableElement = document.getElementById('printable');
						printableElement.style.display = 'block';
						// printableElement.style.position = 'absolute';
						// printableElement.style.visibility = 'hidden';

						let secondLastPageSpacer = document.querySelector('#page_' + (pages.length - 1) +' .spacer');

						// let secondLastPageSpacer = document.querySelector('#page_' + (pages.length - 1) +' .spacer');
						if(secondLastPageSpacer.offsetHeight + 40 > (FOOTER_HEIGHT - hsnSummaryTotalHeight)){
							let footerContent = document.querySelector('.last_page .fullpage_footer');
							let secondLastPage = document.getElementById('page_'+(pages.length - 1));
							secondLastPage.appendChild(footerContent);
						}
                     
						printableElement.style.display = 'none';

						// adding border to last page
						document.querySelector('.last_page').style.borderBottom = "1px solid #000";
						// printableElement.style.position = 'inherit';
						// printableElement.style.visibility = 'inherit';
					}

					// adding class to spacer
					if(this.$root.TransactionSettings.fullPagePrint){
						let pageElements = document.querySelectorAll('#printArea .fullpage');
                        if(pageElements && pageElements.length){
                            for(let p=0; p<pageElements.length; p++){
                                let pageSpacer = document.querySelector('#page_' + (p+1) + '.'+pageElements[p].classList[0] + ' .spacer');
                                if(pageSpacer && !pageSpacer.nextElementSibling){
                                    pageSpacer.classList.add('border_all');
                                }
                            }
                        }
					}
				}, 300);
			}
			
		},

		fn_processItems(type){
			this.pages = this.paginate(type);
			// const root = document.getElementById("printArea");
			var root = null;
			if(type == 'bind_display'){
				root = document.getElementById("displayArea");
			}
			else{
				this.isLoaded = true;
				return;
			}
			// else{
			// 	root = document.getElementById("printArea");
			// }
			

			let grandTotal = 0;

			this.pages.forEach((pageItems, idx) => {

				let rows = '';
				pageItems.forEach(item => {
					const amount = item.qty * item.rate;
					grandTotal += amount;

					rows += `
						<tr id="${item.id}">
							<td>${item.sno}</td>
							<td>${item.name}</td>
							<td align="center">${item.qty}</td>
							<td align="right">${item.rate.toFixed(2)}</td>
							<td align="center">${item.discount}</td>
							<td align="center">${item.taxableValue}</td>
							<td align="center">${item.cgst}</td>
							<td align="center">${item.sgst}</td>
							<td align="right">${amount.toFixed(2)}</td>
						</tr>
					`;
				});

				// <div class="header">
				//         <h2>ABC TRADERS</h2>
				//         GSTIN: 27ABCDE1234F1Z5
				//     </div>
				root.innerHTML += `
				<div class="page fullpage">

					<div class="header">
						<table style="text-align:left">

							<tr>
								<td style='width:50%;padding:0'>
									<div pad4 style="border-bottom:1px #000 solid">
										<h2>ABC TRADERS</h2>
										GSTIN: 27ABCDE1234F1Z5
									</div>

									<div pad4 style="border-bottom:1px #000 solid">
										Bill To <br>
										Abc Party<br>
										Abc Party<br>
										Abc Party<br>
										New Delhi
									</div>

									<div pad4>
										Ship To <br>
										Abc Party<br>
										Abc Party<br>
										Abc Party<br>
										New Delhi
									</div>
								</td>
								<td style="width:25%;padding:4px">
									Invoice No: INV001 <br>
									Invoice Date: 30/12/2025
								</td>
								<td style="width:25%;padding:4px">
									PO No. 001 <br>
									PO Date: 30/12/2025
								</td>
							</tr>
						</table>
					</div>

					<table>
						<thead>
							<tr>
								<th>S.No.</th>
								<th>Description</th>
								<th>Qty</th>
								<th>Rate</th>
								<th>Discount</th>
								<th>Taxable Value</th>
								<th>CGST</th>
								<th>SGST</th>
								<th>Total</th>
							</tr>
						</thead>
						<tbody>
							${rows}
						</tbody>
					</table>

					<div class="spacer">${this.pages.length>1 && idx != this.pages.length - 1 ? 'Continue...' : ''}</div>

					<div class="footer">
						${idx === this.pages.length - 1 ? `
							<table>
								<tr>
									<td><strong>Total amount in words</strong> <br> <span>One Thousand Fifty Only.</span></td>
									<td>
										Taxable Amount (₹): 1,000.00<br>
										Tax @5% (₹): 50.00<br>
										Total Amount (₹): 1,050.00<br>
										Remaining Amount (₹): 1,050.00<br>    
									</td>
								</tr>

								<tr>
									<td>
										<strong>Terms:</strong><br>
										1. All disputes are subject to Delhi Jurisdiction.<br>
										2. Certified that the particulars given above are true and correct.
									</td>
									<td></td>
								</tr>
							</table>
						` : ``}
					</div>

				</div>
				`;
			});

			if(type){
				this.fn_processItems();
			}
		}
	},
	computed:{
		templateClass(){
			if(this.data.templateSettings.invoiceTemplate){
				return 'template_' + this.data.templateSettings.invoiceTemplate;
			}
			else{
				return '';
			}
		}
	},
	mounted: function(){
		// let self= this;
		/* =============================
		CONFIG
		============================= */
		// const PAGE_HEIGHT = 1122;
		// const PAGE_PADDING = 20;
		// const HEADER_HEIGHT = 300;
		// const FOOTER_HEIGHT = 40;
		// const CONTENT_HEIGHT = PAGE_HEIGHT - PAGE_PADDING * 2 - HEADER_HEIGHT - FOOTER_HEIGHT;

		// /* SAMPLE DATA */
		// const items = Array.from({ length: 44 }, (_, i) => ({
		// 	id: `item_${i + 1}`,
		// 	sno:i+1,
		// 	name: `Item ${i + 1} with description that may wrap into multiple lines`,
		// 	qty: (i % 4) + 1,
		// 	rate: 120 + i * 10,
		// 	discount:50,
		// 	taxableValue:1200,
		// 	cgst:100,
		// 	sgst:100,
		// }));

		/* ESTIMATE ROW HEIGHT */
		// function rowHeight(text) {
		// 	return Math.ceil(text.length / 45) * 26;
		// }

		// /* PAGINATE */
		// function paginate(self, items, type) {
		// 	const pages = [];
		// 	let page = [];
		// 	let used = 0;

		// 	if(type){
		// 		items.forEach(item => {
		// 			page.push(item);
		// 		});
		// 	}
		// 	else{
		// 		items.forEach((item, index) => {
		// 			let elementId = "#item_" + (index + 1);
		// 			let rowheight = document.querySelector(elementId);
		// 			// const h = rowHeight(item.name);
		// 			const h = rowheight.offsetHeight;
		// 			if (used + h > CONTENT_HEIGHT) {
		// 				pages.push(page);
		// 				page = [];
		// 				used = 0;
		// 			}
		// 			page.push(item);
		// 			used += h;
		// 		});
		// 	}
		// 	// items.forEach(item => {
		// 		// const h = rowHeight(item.name);
		// 		// if (used + h > CONTENT_HEIGHT) {
		// 			// pages.push(page);
		// 			// page = [];
		// 			// used = 0;
		// 		// }
		// 		// page.push(item);
		// 		// used += h;
		// 	// });

		// 	if (page.length) pages.push(page);
		// 	return pages;
		// }

		// function fn_processItems(type){
		// 	const pages = paginate(self, items, type);
		// 	// const root = document.getElementById("printArea");
		// 	var root = null;
		// 	if(type == 'bind_display'){
		// 		root = document.getElementById("displayArea");
		// 	}
		// 	else{
		// 		root = document.getElementById("printArea");
		// 	}
			

		// 	let grandTotal = 0;

		// 	pages.forEach((pageItems, idx) => {

		// 		let rows = '';
		// 		pageItems.forEach(item => {
		// 			const amount = item.qty * item.rate;
		// 			grandTotal += amount;

		// 			rows += `
		// 				<tr id="${item.id}">
		// 					<td>${item.sno}</td>
		// 					<td>${item.name}</td>
		// 					<td align="center">${item.qty}</td>
		// 					<td align="right">${item.rate.toFixed(2)}</td>
		// 					<td align="center">${item.discount}</td>
		// 					<td align="center">${item.taxableValue}</td>
		// 					<td align="center">${item.cgst}</td>
		// 					<td align="center">${item.sgst}</td>
		// 					<td align="right">${amount.toFixed(2)}</td>
		// 				</tr>
		// 			`;
		// 		});

		// 		// <div class="header">
		// 		//         <h2>ABC TRADERS</h2>
		// 		//         GSTIN: 27ABCDE1234F1Z5
		// 		//     </div>
		// 		root.innerHTML += `
		// 		<div class="page fullpage">

		// 			<div class="header">
		// 				<table style="text-align:left">

		// 					<tr>
		// 						<td left-align class="noborder">
		// 							<div full-height class="title invoice_title pt-1 pb-1 center-align">
		// 								<template>
		// 									${self.data.transactionDetails.invoiceTitle}
		// 								</template>
		// 							</div>
		// 						</td>
		// 					</tr>

		// 					<tr>
		// 						<td style='width:50%;padding:0'>
		// 							<div pad4 style="border-bottom:1px #000 solid">
		// 								<h2>ABC TRADERS</h2>
		// 								GSTIN: 27ABCDE1234F1Z5
		// 							</div>

		// 							<div pad4 style="border-bottom:1px #000 solid">
		// 								Bill To <br>
		// 								Abc Party<br>
		// 								Abc Party<br>
		// 								Abc Party<br>
		// 								New Delhi
		// 							</div>

		// 							<div pad4>
		// 								Ship To <br>
		// 								Abc Party<br>
		// 								Abc Party<br>
		// 								Abc Party<br>
		// 								New Delhi
		// 							</div>
		// 						</td>
		// 						<td style="width:25%;padding:4px">
		// 							Invoice No: INV001 <br>
		// 							Invoice Date: 30/12/2025
		// 						</td>
		// 						<td style="width:25%;padding:4px">
		// 							PO No. 001 <br>
		// 							PO Date: 30/12/2025
		// 						</td>
		// 					</tr>
		// 				</table>
		// 			</div>

		// 			<table>
		// 				<thead>
		// 					<tr>
		// 						<th>S.No.</th>
		// 						<th>Description</th>
		// 						<th>Qty</th>
		// 						<th>Rate</th>
		// 						<th>Discount</th>
		// 						<th>Taxable Value</th>
		// 						<th>CGST</th>
		// 						<th>SGST</th>
		// 						<th>Total</th>
		// 					</tr>
		// 				</thead>
		// 				<tbody>
		// 					${rows}
		// 				</tbody>
		// 			</table>

		// 			<div class="spacer">${pages.length>1 && idx != pages.length - 1 ? 'Continue...' : ''}</div>

		// 			<div class="footer">
		// 				${idx === pages.length - 1 ? `
		// 					<table>
		// 						<tr>
		// 							<td><strong>Total amount in words</strong> <br> <span>One Thousand Fifty Only.</span></td>
		// 							<td>
		// 								Taxable Amount (₹): 1,000.00<br>
		// 								Tax @5% (₹): 50.00<br>
		// 								Total Amount (₹): 1,050.00<br>
		// 								Remaining Amount (₹): 1,050.00<br>    
		// 							</td>
		// 						</tr>

		// 						<tr>
		// 							<td>
		// 								<strong>Terms:</strong><br>
		// 								1. All disputes are subject to Delhi Jurisdiction.<br>
		// 								2. Certified that the particulars given above are true and correct.
		// 							</td>
		// 							<td></td>
		// 						</tr>
		// 					</table>
		// 				` : ``}
		// 			</div>

		// 		</div>
		// 		`;
		// 	});

		// 	if(type){
		// 		fn_processItems();
		// 	}
		// }

		/* RENDER */
		this.headerComponent = require('../components/header_template'+this.data.templateSettings.invoiceTemplate).default;
		setTimeout(() => {
			// this.fn_processItems('bind_display');
			this.paginate();
		}, 2000);

		// <div class="footer">
		//             ${idx === pages.length - 1 ? `
		//                 <strong>Total: ₹${grandTotal.toFixed(2)}</strong>
		//             ` : ``}
		//         </div>
	}
}

</script>

<style>
/* @page { */
    /* size: A4; */
    /* margin: 0; */
/* } */

/* body {
    margin: 0;
    font-family: Arial, sans-serif;
    font-size: 12px;
} */

/* PAGE LAYOUT */
.page.fullpage {
    width: 210mm;
    height: 297mm;
    /* padding: 10mm; */
    box-sizing: border-box;
    page-break-after: always;
	padding-right: 1px;
    display: flex;
    flex-direction: column;
}

.page.fullpage:last-child {
    page-break-after: auto;
}

/* HEADER */
.fullpage .header {
    text-align: center;
    /* border-bottom: 1px solid #000; */
    /* padding-bottom: 6px; */
    /* max-height: 245px; */
	/* height: 300px; */
}

.fullpage .header h2 {
    margin: 0;
}

/* TABLE */
.fullpage table {
    width: 100%;
    border-collapse: collapse;
}

.fullpage thead {
    display: table-header-group;
}

.fullpage th, .fullpage td {
    border: 1px solid #000;
    padding: 4px;
    vertical-align: middle;
}

.fullpage tbody tr {
    page-break-inside: avoid;
}

/* FLEX SPACER */
.fullpage .spacer {
    flex: 1;
	padding-top:8px;
	padding-right: 16px;
	font-size: 14px;
	font-weight: 600;
    /* border: 1px #000 solid; */
    /* border-top:0; */
    text-align: right;
	border-left: 1px #000 solid;
	border-right: 1px #000 solid;
}

.fullpage .spacer.border_all{
	border: 1px #000 solid;
}

.fullpage.last_page .spacer{
	border-top: 0px;
	border-bottom: 0px;
}

/* FOOTER */
.fullpage .fullpage_footer {
    /* border-top: 1px solid #000; */
    /* padding-top: 4px; */
	padding-left: 0px !important;
}

[pad4]{
    padding: 4px;
}
</style>


// WEBPACK FOOTER //
// src/components/invoice_templates/invoices/template1001.vue